import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M22 10v6M2 10l10-5 10 5-10 5z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 12v5c3 3 9 3 12 0v-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "GraduationCap";
const GraduationCap = memo(themed(Icon));
export {
  GraduationCap
};
//# sourceMappingURL=graduation-cap.js.map
